var map = {
	"./AMEX.svg": 81489,
	"./Maestro.svg": 22675,
	"./Mastercard.svg": 89912,
	"./Nexi_white.svg": 11572,
	"./VISA.svg": 83371,
	"./V_Pay.svg": 11177,
	"./Visa_Electron.svg": 95696,
	"./scheme.svg": 57921
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96052;